import { Pipe, PipeTransform } from '@angular/core';
import { HistoryPermissionRow } from '../models/history.model';
import { PermissionChangeTypeEnum } from '@app/admin/user/model/user-history.model';

@Pipe({
  name: 'historyPermissionChange'
})
export class HistoryPermissionChangePipe implements PipeTransform {

  transform(row: HistoryPermissionRow, permission: string): PermissionChangeTypeEnum | null {
    const permissionChange = row.permissions.find(p => p.permission === permission);
    return permissionChange ? permissionChange.changeType : null;
  }

}
